module.exports = __webpack_public_path__ + "46e3c2366734f1efe45ef25676fa1f5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/svg/linkedin.svg
// module id = 1101
// module chunks = 0